








import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, DisableableMixin } from "../mixins";
import { OptionDropDownSelector } from "../selectors";
import { StandardOption } from "../selectors/mixins";
import { ScaleEditableMixin } from "./mixins";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class ScaleDropDownSelector extends Mixins(ModelEditableMixin, ScaleEditableMixin, DisableableMixin) {
  @Prop({ default: true })
  isEnable: boolean;

  @Prop({ default: () => [ 0.5, 0.75, 0.8, 0.85, 0.90, 0.95, 1, 1.25, 1.5, 1.75, 2 ] })
  scales: number[];

  data(): any {
    return {
      options: Enumerable.from(this.scales).select(s => new StandardOption<number>(Math.round(s * 100) + "%", s)).toArray(),
    };
  }
}
